export default "__VITE_ASSET__nF7IrUS9__"